export const userConstants = {
  USER_LOAD: '[User] Load',
  USER_LOAD_SUCCESS: '[User] Load success',
  USER_LOAD_FAILURE: '[User] Load failure',
  USER_RESET: '[User] Reset'
}
